var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 37.9332C18.1834 37.9332 16.3834 37.3999 14.9667 36.3499L7.80008 30.9999C5.90008 29.5832 4.41675 26.6166 4.41675 24.2666V11.8666C4.41675 9.2999 6.30008 6.56657 8.71675 5.66657L17.0334 2.5499C18.6834 1.93324 21.2834 1.93324 22.9334 2.5499L31.2501 5.66657C33.6667 6.56657 35.5501 9.2999 35.5501 11.8666V24.2499C35.5501 26.6166 34.0667 29.5666 32.1667 30.9832L25.0001 36.3332C23.6167 37.3999 21.8167 37.9332 20.0001 37.9332ZM17.9167 4.8999L9.60008 8.01657C8.18341 8.5499 6.93341 10.3499 6.93341 11.8832V24.2666C6.93341 25.8499 8.05008 28.0666 9.30008 28.9999L16.4667 34.3499C18.3834 35.7832 21.6167 35.7832 23.5501 34.3499L30.7167 28.9999C31.9834 28.0499 33.0834 25.8499 33.0834 24.2666V11.8666C33.0834 10.3499 31.8334 8.5499 30.4167 7.9999L22.1001 4.88324C20.9667 4.48324 19.0334 4.48324 17.9167 4.8999Z",
    fill: "#01C37D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7666 23.7167C17.4499 23.7167 17.1332 23.6 16.8832 23.35L14.1999 20.6667C13.7166 20.1834 13.7166 19.3834 14.1999 18.9C14.6832 18.4167 15.4832 18.4167 15.9666 18.9L17.7666 20.7L24.0499 14.4167C24.5332 13.9334 25.3332 13.9334 25.8166 14.4167C26.2999 14.9 26.2999 15.7 25.8166 16.1834L18.6499 23.35C18.3999 23.6 18.0832 23.7167 17.7666 23.7167Z",
    fill: "#01C37D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickShield);
export default __webpack_public_path__ + "static/media/TickShield.5125f86d9af646c765336eba4f557ab7.svg";
export { ForwardRef as ReactComponent };